import { Col, Image, Row } from 'react-bootstrap';
import { formatMoneyShorthand } from 'utils/formatMoney';
import DefaultAvatar from 'components/global/DefaultAvatar';
import { useDrag } from 'react-dnd';
import { $view } from 'signals/global.signals';
import InvestorDealflowContextMenu from 'components/views/InvestorDealflow/_components/InvestorDealflowItemContextMenu';
import RatingBadge from 'components/global/RatingBadge';

const InvestorDealflowGridItem = ({ dealflowItem }) => {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: 'investor',
      options: {
        dropEffect: 'move',
      },
      item: { dealflowItem },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [dealflowItem],
  );

  return (
    <div
      ref={$view.value.isDragDisabled ? null : drag}
      className="py-24 position-relative bg-gray-800 border border-gray-700 rounded px-8"
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: $view.value.isDragDisabled ? 'default' : 'move',
      }}
    >
      <div className="position-absolute top-0 end-0 pe-8">
        <div><small className="text-gray-700">#{dealflowItem.id}: {dealflowItem.name}</small></div>
      </div>
      <Row className="align-items-center">
        <Col sm={2}>
          <div
            className="d-flex justify-content-center rounded-circle flex-shrink-0 profileSettingsAvatar mb-md-0"
            style={{ width: '40px', height: '40px' }}
          >
            {dealflowItem.companyLogo
              ? <Image src={dealflowItem.companyLogo} style={{ objectFit: 'cover' }} />
              : (
                <DefaultAvatar
                  name={dealflowItem.companyName}
                  image={dealflowItem.companyLogo}
                  size="md"
                />
              )}
          </div>
        </Col>
        <Col className="ps-24">
          <div><small className="text-info fw-bold">{dealflowItem.companyName}</small></div>
          <div><small>{formatMoneyShorthand(dealflowItem.currentRaiseSize || 0)} on {formatMoneyShorthand(dealflowItem.currentValue || 0)} valuation</small></div>

          <div><RatingBadge rating={dealflowItem.rating} /></div>
        </Col>
      </Row>
      <div className="position-absolute bottom-0 end-0 d-flex align-items-center">
        <InvestorDealflowContextMenu dealflowItem={dealflowItem} />
      </div>
    </div>
  );
};

export default InvestorDealflowGridItem;
